module.exports = __webpack_public_path__ + "static/media/Sero Image 1920 - 1080.1f171893.png";